import React from "react"
import styled from "styled-components"
import { theme } from "./mixin"

export default function PositionAndWidth({ children, d, m }) {
  return (
    <Wrapper destop={d} mobile={m ? m : d}>
      {children}
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: absolute;
  height: auto;
  width: ${props => (props.destop.width ? props.destop.width : "100%")};
  top: ${props => (props.destop.t ? props.destop.t : "auto")};
  left: ${props => (props.destop.l ? props.destop.l : "auto")};
  right: ${props => (props.destop.r ? props.destop.r : "auto")};
  bottom: ${props => (props.destop.b ? props.destop.b : "auto")};
  transform: rotate(
    ${props => (props.destop.rotate ? props.destop.rotate : "0")}
  );
  z-index: ${props => (props.destop.z ? props.destop.z : "1")};
  @media (${theme.md}) {
    width: ${props => (props.mobile.width ? props.mobile.width : "100%")};
    top: ${props => (props.mobile.t ? props.mobile.t : "auto")};
    left: ${props => (props.mobile.l ? props.mobile.l : "auto")};
    right: ${props => (props.mobile.r ? props.mobile.r : "auto")};
    bottom: ${props => (props.mobile.b ? props.mobile.b : "auto")};
  }
`
